import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobId: null,
  progress: 0,
  processed: 0,
  jobTotal: 0,
  jobStatus: '',
  jobMessage: ''
};

export const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    setJob: (state, action) => {
      state.jobId = action.payload.jobId;
      state.progress = action.payload.progress || 0;
      state.processed = action.payload.processed || 0;
      state.jobTotal = action.payload.jobTotal || 0;
      state.jobStatus = action.payload.jobStatus || '';
      state.jobMessage = action.payload.jobMessage || '';
    },
    updateJobProgress: (state, action) => {
      if (action.payload.progress !== undefined) state.progress = action.payload.progress;
      if (action.payload.processed !== undefined) state.processed = action.payload.processed;
      if (action.payload.total !== undefined) state.jobTotal = action.payload.total;
      if (action.payload.status !== undefined) state.jobStatus = action.payload.status;
      if (action.payload.message !== undefined) state.jobMessage = action.payload.message;
    },
    clearJob: (state) => {
      state.jobId = null;
      state.progress = 0;
      state.processed = 0;
      state.jobTotal = 0;
      state.jobStatus = '';
      state.jobMessage = '';
    }
  }
});

export const { setJob, updateJobProgress, clearJob } = jobSlice.actions;

export default jobSlice.reducer;
